// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"7efaeb03","113":"98b39d7d","127":"1486cdc7","151":"2d3b4431","172":"570f2f08","181":"5a2c8cc7","198":"cbbe9f6d","306":"982c427b","481":"7257a7a6","488":"4397c8fb","700":"61623e1f","721":"4ad98029","746":"60f36b47","941":"9d70fcd4"}[chunkId] + ".chunk.js";
};